<!-- 
    空数据组件
    author:xxk 
    https://element.eleme.cn/#/zh-CN/component/empty
 -->
<template>
  <el-empty v-bind="emptyPropsResult" class="AppEmpty-root" :class="{'hide-img':isHideImg}">
     <!-- 各插槽中转 -->
    <template v-for="name in Object.keys($slots)" #[name]>
      <slot :name="name"></slot>
    </template>
  </el-empty>
</template>
<script>
  export default {
    name: "AppEmpty",
    props: {
      // 组件属性
      emptyProps: {type: Object, default: () => ({})},
      // 是否隐藏图片
      isHideImg: {type: Boolean, default: false},
    },
    computed: {
      // 组件属性合并结果
      emptyPropsResult() {
        return Object.assign(
          {
            description: '暂无相关数据',
            imageSize: 150,
            image: '',
          },
          this.$attrs,
          this.emptyProps
        );
      },
    },
  };
</script>
<style scoped lang="less">
  .AppEmpty-root{ width: 100%; text-align: center; padding: 20px 0; color: #999;font-size: 14px;
    &.hide-img{ 
      /deep/ .el-empty__image{ display: none;}
      /deep/ .el-empty__description{ margin-top: 0;}
    }
    p{ margin-top: 10px;}
  }
</style>